<pdf-viewer [src]="pdfSource"
            [original-size]="false"></pdf-viewer>
